@for (column of columns; track column) {
  @switch (column.type) {
    @case (EnumColumnType.MULTIPLE_LINKS) {
      <ng-container *ngTemplateOutlet="multipleLink; context: { params: { col: column } }"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="SimpleCol; context: { params: { col: column } }"></ng-container>
    }
  }
}

<ng-template #multipleLink let-data="params">
  <div class="table-col">
    <app-column-title [column]="data.col"></app-column-title>

    <div class="d-block column-value">
      @for (pdf of row.downloadPDF; track pdf) {
        <a [href]="occConfig.backend.occ.baseUrl + pdf.url" download target="_blank">
          <i class="fa fa-download"></i>&nbsp;<span>{{ pdf.code }}</span></a
          >
        }
      </div>
    </div>
  </ng-template>

  <ng-template #SimpleCol let-data="params">
    <app-column-control-simple
      class="table-col"
      [row]="row"
      [column]="data.col"
      [style]="data.col.cssStyle"
    ></app-column-control-simple>
  </ng-template>
